import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


/*=====================================================
=            INTERFACES
=====================================================*/

export interface AssistantOption {

  codigo: string;

  nombre: string;

  descripcion?: string;

  icono?: string;

  tipo?: string;

}

export interface WizardStep {

  id: number;

  titulo: string;

  descripcion: string;

}

export interface PreviewClave {

  tipo?: string;

  sistema?: string;

  activo?: string;

  clasificacion?: string;

  instalacion?: string;

  flujo?: string;

  consecutivo?: string;

  clave?: string;

}



@Component({
  selector: 'app-smart-volumetric-assistant.component',
  templateUrl: './smart-volumetric-assistant.component.html',
  styleUrls: ['./smart-volumetric-assistant.component.scss'],
})
export class SmartVolumetricAssistantComponent implements OnChanges {
 
/*=====================================================
=            INPUTS
=====================================================*/

@Input()

assistantType:

    | 'equipment'

    | 'installation'

    | 'measurement'

    = 'equipment';


@Output()

claveGeneradaChange =

new EventEmitter<string>();

@Input() codigoEquipo!: string;

@ViewChild('assistantModal')

assistantModal!: TemplateRef<any>;

modalRef!: NgbModalRef;


/*=====================================================
=            CONFIGURACIÓN
=====================================================*/

assistantConfig = {

equipment:{

title:'Asistente de Equipos',

subtitle:'Genera la clave SAT del equipo.',

icon:'mdi-engine'

},

installation:{

title:'Asistente de Instalaciones',

subtitle:'Genera la clave SAT de la instalación.',

icon:'mdi-office-building'

},

measurement:{

title:'Asistente de Sistemas de Medición',

subtitle:'Genera automáticamente la clave SAT.',

icon:'mdi-ruler-square'

}

};

currentConfig:any;


/*=====================================================
=            WIZARD
=====================================================*/

step=1;

steps:WizardStep[]=[];

search='';


/*=====================================================
=            DATOS GENERALES
=====================================================*/

claveGenerada='';

consecutivo='0001';

clavePozo='';

indicadorInstalacion='';

preview:PreviewClave={};


/*=====================================================
=            SELECCIONES
=====================================================*/


tipoSistemaSeleccionado?:AssistantOption;

activoSeleccionado?:AssistantOption;

clasificacionSeleccionada?:AssistantOption;

instalacionSeleccionada?:AssistantOption;

flujoSeleccionado?:AssistantOption;

tipoPozoSeleccionado?:AssistantOption;


/*=====================================================
=            TIPOS DE SISTEMA
=====================================================*/

tiposSistema:AssistantOption[]=[

{

codigo:'SME',

nombre:'Sistema de Medición Estática',

icono:'mdi-database'

},

{

codigo:'SMD',

nombre:'Sistema de Medición Dinámica',

icono:'mdi-swap-horizontal'

}

];


/*=====================================================
=            ACTIVOS
=====================================================*/

activos:AssistantOption[]=[

{

codigo:'TNQ',

nombre:'Tanque',

tipo:'tank',

icono:'mdi-blood-bag'

},

{

codigo:'DUC',

nombre:'Ducto',

tipo:'pipeline',

icono:'mdi-pipe'

},

{

codigo:'POZ',

nombre:'Pozo',

tipo:'well',

icono:'mdi-oil'

},

{

codigo:'DISP',

nombre:'Dispensario',

tipo:'dispenser',

icono:'mdi-gas-station'

}

];


/*=====================================================
=            CATALOGO ESTÁTICA
=====================================================*/

equiposEstaticos:AssistantOption[]=[

{codigo:'TQS',nombre:'Tanques'},

{codigo:'CTQ',nombre:'Carrotanque'},

{codigo:'MUL',nombre:'Multimodal'},

{codigo:'ATQ',nombre:'Autotanque'},

{codigo:'SMR',nombre:'Semirremolque'},

{codigo:'BTQ',nombre:'Buquetanque'},

{codigo:'VEA',nombre:'Vehículos automotores'},

{codigo:'CAS',nombre:'Caverna salina'},

{codigo:'STQ',nombre:'Tanque subterráneo'}

];


/*=====================================================
=            CATALOGO DINÁMICO TANQUES
=====================================================*/

flujosTanque:AssistantOption[]=[

{

codigo:'ETA',

nombre:'Entrada a medios de almacenamiento'

},

{

codigo:'SDA',

nombre:'Salida a medios de almacenamiento'

}

];


/*=====================================================
=            DUCTOS
=====================================================*/

tiposDucto:AssistantOption[]=[

{

codigo:'TRA',

nombre:'Transporte'

},

{

codigo:'DIS',

nombre:'Distribución'

},

{

codigo:'CAR',

nombre:'Carga'

},

{

codigo:'DES',

nombre:'Descarga'

},

{

codigo:'ETA',

nombre:'Entrada'

},

{

codigo:'SDA',

nombre:'Salida'

}

];


/*=====================================================
=            POZOS
=====================================================*/

tiposPozo:AssistantOption[]=[

{

codigo:'DEL',

nombre:'Delimitador'

},

{

codigo:'EXP',

nombre:'Exploratorio'

},

{

codigo:'DES',

nombre:'Desarrollo'

}

];


/*=====================================================
=            CLASIFICACIONES
=====================================================*/

clasificaciones:AssistantOption[]=[];


/*=====================================================
=            CONSTRUCTOR
=====================================================*/

constructor(

private modalService:NgbModal

){

}


ngOnChanges(changes: SimpleChanges): void {
  console.log('codigoEquipo:', this.codigoEquipo);
  console.log('activos:', this.activos);

  const tipoSistemaSeleccionado = this.activos.find(
    x => x.codigo === this.codigoEquipo
  );

  console.log('Encontrado:', tipoSistemaSeleccionado);

  if (tipoSistemaSeleccionado) {
    this.seleccionarActivo(tipoSistemaSeleccionado);
  }
}


/*=====================================================
=            INSTALACIONES SAT
=====================================================*/

installationTypes: AssistantOption[] = [

  { codigo:'ACA', nombre:'Acceso Abierto' },
  { codigo:'GSH', nombre:'Gas Húmedo' },
  { codigo:'AUP', nombre:'Acceso Abierto - Usos Propios' },
  { codigo:'LON', nombre:'Licuefacción de Gas Natural' },
  { codigo:'ALM', nombre:'Almacenamiento' },
  { codigo:'RPO', nombre:'Recipientes Portátiles sujetos a presión' },
  { codigo:'ACO', nombre:'Autoconsumo o Autoabastecimiento' },
  { codigo:'PTA', nombre:'Planta' },
  { codigo:'BSP', nombre:'Batería de Separación' },
  { codigo:'PDD', nombre:'Planta de Distribución' },
  { codigo:'BDE', nombre:'Bodega de Expendio' },
  { codigo:'PGN', nombre:'Procesamiento de Gas Natural' },
  { codigo:'CMN', nombre:'Comercialización' },
  { codigo:'RCN', nombre:'Recolección' },
  { codigo:'COM', nombre:'Complejo' },
  { codigo:'REF', nombre:'Refinería' },
  { codigo:'CON', nombre:'Compresión' },
  { codigo:'RGN', nombre:'Regasificación' },
  { codigo:'DEN', nombre:'Descompresión' },
  { codigo:'SIS', nombre:'Sistema' },
  { codigo:'DIS', nombre:'Distribución' },
  { codigo:'SFO', nombre:'Sistema Ferroviario' },
  { codigo:'EMA', nombre:'Embarcación Marina' },
  { codigo:'SDA', nombre:'Sociedad de Autoabastecimiento' },
  { codigo:'ESN', nombre:'Estación' },
  { codigo:'TDA', nombre:'Terminal de Almacenamiento' },
  { codigo:'EDS', nombre:'Estación de Servicio para Petrolíferos' },
  { codigo:'TDD', nombre:'Terminal de Distribución' },
  { codigo:'ESA', nombre:'Estación de Servicio para Autoconsumo' },
  { codigo:'TRA', nombre:'Transporte' },
  { codigo:'EXO', nombre:'Expendio' },
  { codigo:'TDP', nombre:'Tratamiento de Petróleo' },
  { codigo:'EXP', nombre:'Exploración' },
  { codigo:'USP', nombre:'Usos Propios' },
  { codigo:'EXT', nombre:'Extracción' }

];


/*=====================================================
=            OPEN
=====================================================*/

open() {

  this.currentConfig =
    this.assistantConfig[this.assistantType];

  this.resetWizard();

  this.configurarWizard();

  this.modalRef =
    this.modalService.open(
      this.assistantModal,
      {
        size:'xl',
        centered:true,
        backdrop:'static',
        windowClass:'assistant-modal'
      }
    );

}


/*=====================================================
=            CLOSE
=====================================================*/

close(){

  if(this.modalRef){

    this.modalRef.close();

  }

}


/*=====================================================
=            CONFIGURAR WIZARD
=====================================================*/

private configurarWizard(){

  switch(this.assistantType){

    case 'equipment':

      this.steps=[

        {
          id:1,
          titulo:'Equipo',
          descripcion:'Selecciona el tipo de equipo'
        },

        {
          id:2,
          titulo:'Clasificación',
          descripcion:'Selecciona la clasificación'
        },

        {
          id:3,
          titulo:'Datos',
          descripcion:'Captura la información'
        },

        {
          id:4,
          titulo:'Resultado',
          descripcion:'Clave generada'
        }

      ];

      break;


    case 'installation':

      this.steps=[

        {
          id:1,
          titulo:'Instalación',
          descripcion:'Selecciona la instalación'
        },

        {
          id:2,
          titulo:'Datos',
          descripcion:'Captura consecutivo'
        },

        {
          id:3,
          titulo:'Resultado',
          descripcion:'Clave generada'
        }

      ];

      break;


    case 'measurement':

      this.steps=[

        {
          id:1,
          titulo:'Sistema',
          descripcion:'Estática o Dinámica'
        },

        {
          id:2,
          titulo:'Equipo',
          descripcion:'Selecciona el activo'
        },

        {
          id:3,
          titulo:'Configuración',
          descripcion:'Configura el sistema'
        },

        {
          id:4,
          titulo:'Resultado',
          descripcion:'Clave generada'
        }

      ];

      break;

  }

}


/*=====================================================
=            RESET
=====================================================*/

resetWizard(){

  this.step=1;

  this.search='';

  this.claveGenerada='';

  this.consecutivo='0001';

  this.indicadorInstalacion='';

  this.clavePozo='';

  this.preview={};

  this.tipoSistemaSeleccionado=undefined;

  this.activoSeleccionado=undefined;

  this.clasificacionSeleccionada=undefined;

  this.instalacionSeleccionada=undefined;

  this.flujoSeleccionado=undefined;

  this.tipoPozoSeleccionado=undefined;

  this.clasificaciones=[];

}


/*=====================================================
=            NAVEGACIÓN
=====================================================*/

next(){

  this.step++;

}

previous(){

  if(this.step>1){

    this.step--;

  }

}


/*=====================================================
=            SELECCIONES
=====================================================*/

seleccionarTipoSistema(item:AssistantOption){
  console.log(item);
  this.tipoSistemaSeleccionado=item;

  this.step=2;

}


seleccionarActivo(item:AssistantOption){
  console.log(item);
  this.activoSeleccionado=item;

  this.cargarClasificaciones();

  this.step = 2;
 console.log('step:', this.step);
}


seleccionarClasificacion(item:AssistantOption){

  this.clasificacionSeleccionada=item;

}


seleccionarInstalacion(item:AssistantOption){

  this.instalacionSeleccionada=item;

  this.step = 2;

}


seleccionarFlujo(item:AssistantOption){

  this.flujoSeleccionado=item;

}


seleccionarTipoPozo(item:AssistantOption){

  this.tipoPozoSeleccionado=item;

}


/*=====================================================
=            CARGAR CLASIFICACIONES
=====================================================*/

private cargarClasificaciones(){

  this.clasificaciones=[];

  if(!this.activoSeleccionado){

    return;

  }

  switch(this.activoSeleccionado.tipo){

    case 'tank':

      this.clasificaciones=
        this.equiposEstaticos;
      break;

    case 'pipeline':

      this.clasificaciones=
        this.tiposDucto;
      break;

    case 'well':

      this.clasificaciones=
        this.tiposPozo;
      break;

    case 'dispenser':

      this.clasificaciones=[
        {
          codigo:'DISP',
          nombre:'Dispensario'
        }
      ];
      break;

  }

}


/*=====================================================
=            FILTRO INSTALACIONES
=====================================================*/

get instalacionesFiltradas(){

  if(!this.search){

    return this.installationTypes;

  }

  const texto=
    this.search.toLowerCase();

  return this.installationTypes.filter(x=>

      x.codigo.toLowerCase().includes(texto)

      ||

      x.nombre.toLowerCase().includes(texto)

  );

}


/*=====================================================
=            VALIDACIONES
=====================================================*/

get puedeGenerar(){

  switch(this.assistantType){

    case 'equipment':

      return !!(

        this.activoSeleccionado &&

        this.clasificacionSeleccionada

      );

    case 'installation':

      return !!(

        this.instalacionSeleccionada

      );

    case 'measurement':

      return !!(

        this.tipoSistemaSeleccionado &&

        this.activoSeleccionado

      );

    default:

      return false;

  }


}
  /*=====================================================
=            GENERADOR PRINCIPAL
=====================================================*/

generarClave() {

  if (!this.puedeGenerar) {
    return;
  }

  switch (this.assistantType) {

    case 'equipment':

      this.claveGenerada =
        this.generarEquipo();

      break;

    case 'installation':

      this.claveGenerada =
        this.generarInstalacion();

      break;

    case 'measurement':

      this.claveGenerada =
        this.generarSistemaMedicion();

      break;

  }

  this.actualizarPreview();

  this.claveGeneradaChange.emit(
    this.claveGenerada
  );

  this.step =
    this.steps.length;

}


/*=====================================================
=            EQUIPOS
=====================================================*/

private generarEquipo(): string {

  if (
    !this.activoSeleccionado ||
    !this.clasificacionSeleccionada
  ) {
    return '';
  }

  const numero =
    this.consecutivo.padStart(4,'0');

  switch (this.activoSeleccionado.tipo) {

    case 'tank':

      return `${this.clasificacionSeleccionada.codigo}-${this.instalacionSeleccionada}-${numero}`;

    case 'pipeline':

      return `DUC-${this.clasificacionSeleccionada.codigo}-${numero}`;

    case 'well':

      return `POZ-${this.clavePozo}-${numero}${this.clasificacionSeleccionada.codigo}`;

    case 'dispenser':

      return `DISP-${numero}`;

    default:

      return '';

  }

}


/*=====================================================
=            INSTALACIONES
=====================================================*/

private generarInstalacion(): string {

  if(!this.instalacionSeleccionada){

    return '';

  }

  return `${

      this.instalacionSeleccionada.codigo

  }-${

      this.consecutivo.padStart(4,'0')

  }`;

}


/*=====================================================
=            SISTEMAS DE MEDICIÓN
=====================================================*/

private generarSistemaMedicion(): string {

  if(!this.tipoSistemaSeleccionado){

    return '';

  }

  if(this.tipoSistemaSeleccionado.codigo==='SME'){

    return this.generarSME();

  }

  return this.generarSMD();

}


/*=====================================================
=            SME
=====================================================*/

private generarSME():string{

  if(

      !this.clasificacionSeleccionada ||

      !this.instalacionSeleccionada

  ){

      return '';

  }

  return `SME-${
      this.clasificacionSeleccionada.codigo
  }-${
      this.instalacionSeleccionada.codigo
  }-${
      this.consecutivo.padStart(4,'0')
  }`;

}


/*=====================================================
=            SMD
=====================================================*/

private generarSMD():string{

  if(!this.activoSeleccionado){

      return '';

  }

  switch(this.activoSeleccionado.tipo){

      case 'tank':

          return this.generarSMDTanque();

      case 'pipeline':

          return this.generarSMDDucto();

      case 'well':

          return this.generarSMDPozo();

      case 'dispenser':

          return this.generarSMDDispensario();

      default:

          return '';

  }

}


/*=====================================================
=            SMD TANQUE
=====================================================*/

private generarSMDTanque():string{

    if(

        !this.flujoSeleccionado ||

        !this.clasificacionSeleccionada ||

        !this.instalacionSeleccionada

    ){

        return '';

    }

    return `SMD-${
        this.flujoSeleccionado.codigo
    }-${
        this.clasificacionSeleccionada.codigo
    }-${
        this.instalacionSeleccionada.codigo
    }-${
        this.consecutivo.padStart(4,'0')
    }`;

}


/*=====================================================
=            SMD DUCTO
=====================================================*/

private generarSMDDucto():string{

    if(

        !this.clasificacionSeleccionada

    ){

        return '';

    }

    return `SMD-DUC-${
        this.clasificacionSeleccionada.codigo
    }-${
        this.consecutivo.padStart(4,'0')
    }`;

}


/*=====================================================
=            SMD POZO
=====================================================*/

private generarSMDPozo():string{

    if(

        !this.tipoPozoSeleccionado ||

        !this.clavePozo

    ){

        return '';

    }

    return `SMD-POZ-${
        this.clavePozo.toUpperCase()
    }-${
        this.consecutivo.padStart(4,'0')
    }${
        this.tipoPozoSeleccionado.codigo
    }`;

}


/*=====================================================
=            SMD DISPENSARIO
=====================================================*/

private generarSMDDispensario():string{

    return `SMD-DISP-${
        this.consecutivo.padStart(4,'0')
    }`;

}


/*=====================================================
=            PREVIEW
=====================================================*/

private actualizarPreview(){

    this.preview={

        sistema:
            this.tipoSistemaSeleccionado?.nombre,

        activo:
            this.activoSeleccionado?.nombre,

        clasificacion:
            this.clasificacionSeleccionada?.nombre,

        instalacion:
            this.instalacionSeleccionada?.nombre,

        flujo:
            this.flujoSeleccionado?.nombre,

        consecutivo:
            this.consecutivo,

        clave:
            this.claveGenerada

    };

}


/*=====================================================
=            COPIAR
=====================================================*/

async copiarClave(){

    try{

        await navigator.clipboard.writeText(

            this.claveGenerada

        );

        this.claveGeneradaChange.emit(

            this.claveGenerada

        );

        this.close();

    }
    catch(e){

        console.error(e);

    }

}


/*=====================================================
=            NUEVA CLAVE
=====================================================*/

nuevo(){

    this.resetWizard();

}

}








